import { useFocusEffect, useNavigation, useRoute } from '@react-navigation/native';
import React, { useCallback, useContext } from 'react';
import { Text, View, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import { AuthContext } from '../../contexts/auth/Store';

const AddToHomeScreen: React.FC = () => {
    const navigation = useNavigation();
    const route = useRoute();
    const auth = useContext(AuthContext);

    const buttonClickHandler = async () => {
        try {
            let deferredPrompt = await auth.state.install_prompt.prompt();
            const { outcome } = deferredPrompt; // dismissed | accepted
            // Optionally, send analytics event with outcome of user choice
            // console.log(`User response to the install prompt: ${outcome}`);
        } catch (e) {
            console.log(e)
        }
    }

    return <>
        {
            auth.state.install_prompt
                ? <View style={styles.container}>
                    <View style={styles.headerContainer}>
                        <Text style={styles.header}>Suplias</Text>
                        <Text style={styles.subHeader}>Get our free app. It won’t take up space on your phone.</Text>
                    </View>
                    <TouchableOpacity style={styles.buttonContainer} onPress={buttonClickHandler}>
                        <Text style={styles.buttonText}>Install</Text>
                    </TouchableOpacity>
                </View>
                : null
        }
    </>
}

export default AddToHomeScreen

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 16,
        backgroundColor: Colors.darkerTintColor,
    },
    headerContainer: {
        flexShrink: 1
    },
    header: {
        ...FontStyles.white,
        ...FontStyles.semibold,
        ...FontStyles.size14,
        ...FontStyles.lh16,
    },
    subHeader: {
        ...FontStyles.gray,
        ...FontStyles.medium,
        ...FontStyles.size12,
        ...FontStyles.lh14,
    },
    buttonContainer: {
        borderRadius: 100,
        paddingHorizontal: 10,
        paddingVertical: 6,
        backgroundColor: Colors.shades._5
    },
    buttonText: {
        ...FontStyles.dark,
        ...FontStyles.semibold,
        ...FontStyles.size14,
        ...FontStyles.lh16,
    },
})